// extracted by mini-css-extract-plugin
module.exports = {"btn-start-peer-review":"PeerReviewButton_btn-start-peer-review__2_w9L","btn-content":"PeerReviewButton_btn-content__5vku1"};